import NoDataFound from 'Components/Common/NoDataFound'
import ContentMasonry from 'Components/social-account/ContentMasonry'
import PostPreview from 'Components/social-account/PostPreview'
import PostPreviewCreator from 'Components/social-account/PostPreviewCreator'
import { useElementWidth } from 'hooks/useElementWidth'
import React, { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useDispatch, useSelector } from 'react-redux'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { Link } from 'react-router-dom'
import { fetchCompetitionContentThunk } from 'slices/competitionAnalysis/thunk'
import { toggleManageCollectionModal } from 'slices/ui/reducer'
import { AppDispatch, RootState } from 'store'
import { SocialPost } from 'types/campaign/collaborations'
import { defaultCompetitionContentFilters } from 'types/competition-analysis'
import { generateUniqueKey } from 'utils/helpers'

const filters = defaultCompetitionContentFilters;

const CompetitionContentPreview = () => {

    const dispatch: AppDispatch = useDispatch();
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));

    const competitionContentData = useSelector((state: RootState) => state.competitionAnalysis.content?.filtered_lists[filterId]);
    const content = competitionContentData?.items ?? [];
    const [loading, setLoading] = useState(false);
    const wrapperRef = useRef<any>(null);
    const rowWidth = useElementWidth(wrapperRef);

    const bookmark = async (e: any, post: SocialPost) => {
        e.stopPropagation();
        e.preventDefault();
        dispatch(toggleManageCollectionModal({ post, creator: null, itemType: 'post', addMode: true }))
    }

    useEffect(() => {
        setLoading(true);
        dispatch(fetchCompetitionContentThunk({ filters })).finally(() => setLoading(false));
    }, [filters])

    return (
        <div className='dashboard-section'>
            <div className="dashboard-section-header">
                <h5>Your competitors recent content</h5>
                <Link className='dashboard-section-header-view-more' to={{ pathname: '/competitor', search: '?tab=content' }}>View All</Link>
            </div>
            <div className="dashboard-section-body">
                <div ref={wrapperRef}>
                    <ResponsiveMasonry
                        columnsCountBreakPoints={{
                            350: 1,
                            750: 2,
                            900: 3,
                            1200: 4,
                            1500: Math.floor(rowWidth / 230) || 5
                        }}
                        gutterBreakPoints={{
                            350: '24px',
                        }}
                    >
                        <Masonry>
                            {content.map((post) => post.social_post).map((post, i) => (
                                <div key={i} className='masonry-item' id={`masonry-item-${i}`}>
                                    <PostPreview post={post} onHoverActions={
                                        <span onClick={(e) => bookmark(e, post)} className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M17.5 13.4084V9.24728C17.5 5.67344 17.5 3.88652 16.4017 2.77627C15.3033 1.66602 13.5355 1.66602 10 1.66602C6.46447 1.66602 4.6967 1.66602 3.59835 2.77627C2.5 3.88652 2.5 5.67344 2.5 9.24728V13.4084C2.5 15.9889 2.5 17.2791 3.11176 17.8429C3.40351 18.1118 3.77179 18.2807 4.1641 18.3256C4.98668 18.4198 5.94728 17.5701 7.86847 15.8709C8.71768 15.1198 9.14229 14.7442 9.63356 14.6452C9.87548 14.5965 10.1245 14.5965 10.3664 14.6452C10.8577 14.7442 11.2823 15.1198 12.1315 15.8709C14.0527 17.5701 15.0133 18.4198 15.8359 18.3256C16.2282 18.2807 16.5965 18.1118 16.8882 17.8429C17.5 17.2791 17.5 15.9889 17.5 13.4084Z" stroke="white" strokeWidth="1.25" />
                                                <path d="M12.5 5H7.5" stroke="white" strokeWidth="1.25" strokeLinecap="round" />
                                            </svg>
                                        </span>
                                    } />
                                    {
                                        post.social_account &&
                                        <PostPreviewCreator socialAccount={post.social_account} />
                                    }
                                </div>
                            ))}
                            {
                                (loading) &&
                                Array.from({ length: 10 }).map((_, i) => (
                                    <div key={i} className="explore-item w-100">
                                        <Skeleton width={`100%`} height={i % 2 === 0 ? 420 : 340} />
                                    </div>
                                ))
                            }
                        </Masonry>
                    </ResponsiveMasonry>
                </div>
                {(content.length === 0 && !loading) && <div className="my-5"><NoDataFound message='Currently there is no post in your list!' /></div>}
            </div>
        </div>
    )
}

export default CompetitionContentPreview